import { useParams } from "react-router-dom";
import Nav from "../layout/nav/desktopNav";
import MobileNav from "../layout/nav/mobileNav";
import Header from "../components/page-title/header.js";
import Footer from "../components/footer/Footer.js";
import Text from "../components/references/text.js";
import Data from "../components/references/data/Data.js";
import CustomerPreferences from "../components/references/customer-preferences.js";
import CustomerReview from "../components/references/customer-review.js";
import Slider from "../components/references/realisation-images.js";

function Reference() {
  const { url } = useParams();

  // Find the corresponding service based on the ID
  const realisation = Data.find((item) => item.url === url);

  const title = `${realisation.subject} | ${realisation.city}`;

  return (
    <div>
      <Nav />
      <MobileNav />

      <Header
        title={title}
        image={realisation.image}
        showImage={true}
        showGoBack={true}
      />
      <Text text={realisation.introText} />
      <CustomerPreferences items={Data} />
      <CustomerReview items={Data} />
      <Text
        text={
          "Nieuwsgierig naar de transformatie? Neem de controle, klik op de pijltjes en ervaar de kracht van verandering."
        }
        layout="start"
        colorText="black"
        bgColor="white"
      />
      <Slider items={Data} />
      <Footer />
    </div>
  );
}

export default Reference;
